export default __webpack_public_path__ + "static/media/e-ppt-picturemark-l.dc97be52.svg";